import { CurrencyPipe, DatePipe, SlicePipe } from '@angular/common';
import { NO_ERRORS_SCHEMA, NgModule, Optional, SkipSelf, inject, provideAppInitializer } from '@angular/core';

import { ProductService } from '@frontend/vanilla/core';

// Vanilla overrides
import { AuthModule } from '../auth/index';
import { BetHistoryApiModule } from '../betHistory/bet-history-api.module';
import { BetslipApiModule } from '../betslip/betslip-api.module';
import { BmaModule } from '../bma/bma.module';
import { BppModule } from '../bpp/bpp.module';
import { FavouritesModule } from '../favourites/favourites.module';
import { InplayApiModule } from '../inPlay/inplay-api.module';
import { SharedModule } from '../shared/shared.module';
import { CustomHttpClientService } from './custom-http-client.service';
import { httpInterceptorProviders } from './httpInterceptors';
import { BrowserUrlInterceptor } from './httpInterceptors/browser-url-interceptor';
import { LocaleInterceptor } from './httpInterceptors/locale-interceptor.service';
import { MaintenanceInterceptor } from './httpInterceptors/maintenance-interceptor.service';
import { moduleImportGuard } from './module-import.guard';
import { brandConfig, brandConfigToken } from './services/brand/brand.config';
import { CoreRunService } from './services/coreRun/core-run.service';
import { greyhoundConfig } from './services/racing/config/greyhound.config';
import { horseracingConfig } from './services/racing/config/horseracing.config';

@NgModule({
    // define all feature modules + shared module
    imports: [BetslipApiModule, BetHistoryApiModule, InplayApiModule, SharedModule, BppModule, AuthModule, BmaModule, FavouritesModule],

    // define app level services/providers
    providers: [
        { provide: brandConfigToken, useValue: brandConfig },
        DatePipe,
        SlicePipe,
        CurrencyPipe,
        httpInterceptorProviders,
        { provide: 'HORSERACING_CONFIG', useValue: horseracingConfig },
        { provide: 'GREYHOUND_CONFIG', useValue: greyhoundConfig },
        provideAppInitializer(() => {
            const initializerFn = (function (coreRunService: CoreRunService) {
                return function () {
                    coreRunService.init();
                };
            })(inject(CoreRunService));
            return initializerFn();
        }),
    ],
    // avoid declarations, shared ui components should be in shared module,
    schemas: [NO_ERRORS_SCHEMA],
})
export class CoreModule {
    constructor(
        @Optional() @SkipSelf() parentModule: CoreModule,
        private customHttpClientService: CustomHttpClientService,
        private productService: ProductService,
    ) {
        if (this.productService.isSingleDomainApp) {
            this.customHttpClientService.initialize([new LocaleInterceptor(), new BrowserUrlInterceptor(), new MaintenanceInterceptor()]);
        }
        moduleImportGuard(parentModule, 'CoreModule');
    }
}
